import React from 'react';

const LEGEND_ITEMS = [
  {
    key: 'in',
    icon: 'bi-box-arrow-in-right',
    label: 'In',
    source: 'HRX',
    hint: 'Clock-in',
    title: 'HRX clock-in time'
  },
  {
    key: 'out',
    icon: 'bi-box-arrow-right',
    label: 'Out',
    source: 'HRX',
    hint: 'Clock-out',
    title: 'HRX clock-out time'
  },
  {
    key: 'obs',
    icon: 'bi-display',
    label: 'Obs',
    source: 'Observant',
    hint: 'Tracked time',
    title: 'Observant tracked time'
  },
  {
    key: 'worked',
    icon: 'bi-clock-history',
    label: 'Worked',
    source: 'HRX',
    hint: 'Worked time',
    title: 'HRX worked time'
  }
];

const ViolationTimeLegend = ({ className = '', compact = false }) => (
  <div
    className={`att-violation-time-legend${compact ? ' att-violation-time-legend--compact' : ''}${
      className ? ` ${className}` : ''
    }`}
    role="note"
    aria-label="Attendance time legend"
  >
    <div className="att-violation-time-legend__head">
      <i className="bi bi-info-circle att-violation-time-legend__icon" aria-hidden />
      <span className="att-violation-time-legend__title">Time fields</span>
      {!compact ? (
        <span className="att-violation-time-legend__subtitle">Shown on each violation row</span>
      ) : null}
    </div>

    <div className="att-violation-time-legend__items">
      {LEGEND_ITEMS.map((item) => (
        <span
          key={item.key}
          className={`att-violation-time-legend__chip att-violation-time-legend__chip--${item.key}`}
          title={item.title}
        >
          <span className="att-violation-time-legend__chip-icon" aria-hidden>
            <i className={`bi ${item.icon}`} />
          </span>
          <span className="att-violation-time-legend__chip-text">
            <span className="att-violation-time-legend__chip-label">{item.label}</span>
            <span className="att-violation-time-legend__chip-meta">
              <span className="att-violation-time-legend__chip-source">{item.source}</span>
              {!compact ? (
                <span className="att-violation-time-legend__chip-hint">{item.hint}</span>
              ) : null}
            </span>
          </span>
        </span>
      ))}
    </div>
  </div>
);

export default ViolationTimeLegend;
